import React from 'react'
import {
    FooterContainer,
    FooterLink,
    FooterLinkContainer,
    FooterLinkItems,
    FooterLinkTitle,
    FooterLinkWrapper,
    FooterWrap,
    SocialIconLink,
    SocialIcons,
    SocialLogo,
    SocialMedia,
    SocialMediaWrap,
    WebsiteRights
} from './FooterElements'
import {
    FaTelegramPlane,
    FaTwitter,
    FaGithubAlt
} from 'react-icons/fa'
import { animateScroll as scroll } from 'react-scroll';

const Footer = () => {

    const toggleHome = () => {
        scroll.scrollToTop()
    }

    return (
        <>
            <FooterContainer>
                <FooterWrap>
                    <FooterLinkContainer>
                        <FooterLinkWrapper>
                            <FooterLinkItems>
                                <FooterLinkTitle>About Us</FooterLinkTitle>
                                <FooterLink href="https://app.adappter.xyz" target="_blank">Enter App</FooterLink>
                                <FooterLink href="https://litepaper.adappter.xyz" target="_blank">Litepaper</FooterLink>
                                <FooterLink href="#" target="_blank">Github</FooterLink>
                            </FooterLinkItems>
                            <FooterLinkItems>
                                <FooterLinkTitle>Demo</FooterLinkTitle>
                                <FooterLink href="https://minionprotocol.com">RPA Agent</FooterLink>
                                <FooterLink href="https://drag.demo.adappter.xyz/">Transfer</FooterLink>
                                <FooterLink href="https://auth.demo.adappter.xyz/">Authentication</FooterLink>
                                  </FooterLinkItems>
                        </FooterLinkWrapper>
                        <FooterLinkWrapper>
                            <FooterLinkItems>
                                <FooterLinkTitle>Contact Us</FooterLinkTitle>
                                <FooterLink href="mailto:kwang@adappter.xyz">Email</FooterLink>
                                <FooterLink href="https://www.youtube.com/@AdappterXYZ">Youtube</FooterLink>
                                <FooterLink href="https://twitter.com/adappterxyz">Twitter</FooterLink>
                            </FooterLinkItems>
                        </FooterLinkWrapper>
                    </FooterLinkContainer>
                    <SocialMedia>
                        <SocialMediaWrap>
                            <SocialLogo to="/" onClick={toggleHome}>
                                AdappterXYZ
                            </SocialLogo>
                            <WebsiteRights>{new Date().getFullYear()} All rights reserved.
                            </WebsiteRights>
                            <SocialIcons>
                                <SocialIconLink
                                    href="https://t.me/adappter_community"
                                    target="_blank"
                                    aria-label="Telegram">
                                    <FaTelegramPlane />
                                </SocialIconLink>
                                <SocialIconLink
                                    href="https://twitter.com/_adappter_"
                                    target="_blank"
                                    aria-label="Twitter">
                                    <FaTwitter />
                                </SocialIconLink>
                                <SocialIconLink
                                    href="https://litepaper.adappter.xyz"
                                    target="_blank"
                                    aria-label="Gitbook">
                                    <FaGithubAlt />
                                </SocialIconLink>
                            </SocialIcons>
                        </SocialMediaWrap>
                    </SocialMedia>
                </FooterWrap>
            </FooterContainer>
        </>
    )
}

export default Footer
